/**
 *
 * AssetPickerFilter
 *
 */
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { BudgetPicker } from 'app/components/pickers/AutocompletePickers/BudgetPicker';

export const ProjectFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <BudgetPicker
      value={props.value}
      onChange={handleOnChange}
      isOpen={props.open}
      placeholder={t(translations.AllBudgets)}
      size="small"
      ariaLabel={props.label}
      id={props.id}
      allActiveBudgets={true}
      predicates={props.predicates}
      onPickerOpen={props.onOpen}
    />
  );
};
export default ProjectFilter;
